// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../sharedmodules/action-creators/busy-counter';
import actions from '../../../../sharedmodules/actions-list';
import { getDivision } from '../../shared/repositories';
import { handleError } from '../../../../sharedmodules/services/error-handlers';

export const updateDivisionParams = (getAccessToken) => async (dispatch) => {

    dispatch(busyCounter.increaseBusyCounter());

    try {

        const division = await getDivision(getAccessToken);

        dispatch({
            division,
            type: actions.UPDATE_DIVISION_SUCCESS,
        });

    } catch (error) {

        handleError(error);

    } finally {

        dispatch(busyCounter.decreaseBusyCounter());

    }

};
